import { FormattedMessage } from 'react-intl';
import { Feature } from '../models';
import { ListIcon, ListRow, ListCentered } from './styled/List';

interface Props {
  features: Feature[];
}

export const FeatureList = (props: Props) => (
  <ListCentered>
    {
      props.features.map((feature, index) => (
        <ListRow key={index}>
          <FormattedMessage id={feature.key.toLowerCase()} />
          <ListIcon className="material-icons" checked={feature.checked}>
            { feature.checked ? 'check' : 'close' }
          </ListIcon>
        </ListRow>
      ))
    }
  </ListCentered>
);
